module.exports = __webpack_public_path__ + "img/charger-icon.23247c2f.png";